// Layouts
import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
import AuthLayout from "@/layout/Auth/AuthLayout.vue";

// Chart pages
import PointsChart from "@/pages/charts/Points.vue";

// Contracts pages
import ContractCreator from "@/pages/contracts/ContractCreator.vue";
import ContractFail from "@/pages/contracts/ContractFail.vue";
import Contracts from "@/pages/contracts/Contracts.vue"

// Queue pages
import CobrancaAviso from "@/pages/queue/CobrancaAviso.vue";
import CobrancaCancelado from "@/pages/queue/CobrancaCancelado.vue";
import CobrancaBloqueado from "@/pages/queue/CobrancaBloqueado.vue";
import CobrancaGenerica from "@/pages/queue/CobrancaGenerica.vue";

// SMS
import EnvioSMS from "@/pages/sms/EnvioSMS.vue";

// Plans
import Plans from '@/pages/plans-showcase/PlanShowCaseList.vue';
import Combos from '@/pages/plans-showcase/Combos.vue';
import CreateCombo from '@/pages/plans-showcase/CreateCombo.vue';

// Leads
import Leads from '@/pages/leads/Leads.vue';
import ViewLead from '@/pages/leads/ViewLead.vue';
import RegisterLead from '@/pages/leads/RegisterLead.vue'

// Points
import RegisterPoint from '@/pages/points/RegisterPoint.vue'
import UpdatePointPlan from '@/pages/points/UpdatePointPlan.vue'

// Clients
import Clients from '@/pages/clients/Clients.vue';
import ViewClient from '@/pages/clients/ViewClient.vue'

// Cars
import CarDrives from '@/pages/cars/CarDrives.vue';
import Cars from '@/pages/cars/Cars.vue';
import Drivers from '@/pages/cars/Drivers.vue';
import ViewDrivers from '@/pages/cars/ViewDrivers.vue';
import RegisterDrivers from '@/pages/cars/RegisterDrivers.vue';
import RegisterCarDrive from '@/pages/cars/RegisterCarDrive.vue'
import ViewCarDrive from '@/pages/cars/ViewCarDrive.vue'

// InternalAffairs
import InternalAffairs from '@/pages/internal-affairs/InternalAffairs.vue'
import ViewInternalAffair from '@/pages/internal-affairs/ViewInternalAffair.vue'

// Auth pages
import Login from "@/pages/auth/Login.vue";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard-pontos",
    children: [
      {
        path: "dashboard-pontos",
        name: "dashboard",
        component: PointsChart,
      },
      {
        path: "cobranca-aviso",
        name: "cobranca-aviso",
        component: CobrancaAviso
      },
      {
        path: "cobranca-cancelado",
        name: "cobranca-cancelado",
        component: CobrancaCancelado
      },
      {
        path: "cobranca-bloqueado",
        name: "cobranca-bloqueado",
        component: CobrancaBloqueado
      },
      {
        path: "cobranca-generica",
        name: "cobranca-generica",
        component: CobrancaGenerica
      },
      {
        path: "contratos-criar",
        name: "contratos-criar",
        component: ContractCreator
      },
      {
        path: "contratos-falhos",
        name: "contratos-falhos",
        component: ContractFail
      },
      {
        path: "contratos",
        name: "contratos",
        component: Contracts
      },
      {
        path: "envio-sms",
        name: "envio-sms",
        component: EnvioSMS
      },
      {
        path: "planos",
        name: "planos",
        component: Plans
      },
      {
        path: "combos",
        name: "Combos Cadastrados",
        component: Combos
      },
      {
        path: "cadastrar-combo",
        name: "cadastrar um novo combo",
        component: CreateCombo
      },
      {
        path: "leads",
        name: "Lista de Leads",
        component: Leads
      },
      {
        path: "leads/:id",
        name: "visualizar dados do lead",
        component: ViewLead
      },
      {
        path: "cadastrar-lead",
        name: "cadastrar um novo lead",
        component: RegisterLead
      },
      {
        path: "clientes",
        name: "clientes",
        component: Clients
      },
      {
        path: "clientes/:id/visualizar",
        name: "visualizar cliente",
        component: ViewClient

      },
      {
        path: "clientes/:id/cadastrar-ponto",
        name: "cadastrar ponto",
        component: RegisterPoint
      },
      {
        path: "clientes/:clientId/pontos/:pointId/atualizar-plano",
        name: "atualizar-ponto-plano",
        component: UpdatePointPlan
      },
      {
        path: "movimentacao-carros",
        name: "movimentacao-carros",
        component: CarDrives
      },
      {
        path: "cadastrar-movimentacao-carro",
        name: "cadastrar-movimentacao-carro",
        component: RegisterCarDrive
      },
      {
        path: "carros-cadastrados",
        name: "carros-cadastrados",
        component: Cars
      },
      {
        path: "motoristas-cadastrados",
        name: "motoristas-carro-cadastrados",
        component: Drivers
      },
      {
        path: "motoristas-cadastrados/:id",
        name: "visualizar-motoristas-carro-cadastrados",
        component: ViewDrivers
      },
      {
        path: "movimentacao-carros/:id",
        name: "visualizar-movimentacao-carro-cadastrados",
        component: ViewCarDrive
      },
      {
        path: "cadastrar-motorista",
        name: "cadastrar-motorista-carro",
        component: RegisterDrivers
      },
      {
        path: "atendimentos",
        name: "atendimentos (ouvidoria)",
        component: InternalAffairs
      },
      {
        path: "atendimento/:id/visualizar",
        name: "visualizar atendimento",
        component: ViewInternalAffair
      }
    ]
  },
  {
    path: '/auth',
    component: AuthLayout,
    redirect: '/auth/login',
    children: [
      {
        path: 'login',
        name: 'Login',
        component: Login
      }
    ]
  },
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
